<script setup>
import { ref, watch, nextTick } from "vue";
import { useArticleBase } from "../hooks/useArticleBase";
import ImageSlider from "./ImageSlider.vue";
import SlideBtn from "./SlideBtn.vue";
import PlayVideo from "./PlayVideo.vue";

const { length, idx, article, articles } = useArticleBase("story");
const accActive = ref(false);
const filteredArticles = ref([]);

watch(idx, async () => {
    await nextTick(); // DOM更新が終わるのを待つ
    const contents = document.querySelector(".l-section.-story");

    if (contents.classList.contains("-storyChange")) {
        contents.classList.remove("-storyChange");
    }
    contents.setAttribute("data-reveal", 0);
    void contents.offsetWidth; // Reflowを強制する

    setTimeout(() => {
        contents.setAttribute("data-reveal", 1);
        contents.classList.add("-storyChange");
    }, 50);
});

const updateFilteredArticles = () => {
    filteredArticles.value = articles.filter((_, index) => index !== idx.value);
};

watch(idx, updateFilteredArticles);
updateFilteredArticles();
</script>

<template>
    <div class="story__acc">
        <div class="story__acc__head" @click="accActive = !accActive">
            <div class="story__numWrap">
                <span class="story__num tk-dystopian">#{{ article.fields.episode }}</span>
            </div>
            <button class="story__acc__btn"></button>
        </div>
        <div class="story__acc__contents" :class="{ '-open': accActive }">
            <ul class="story__lists">
                <li class="story__list" v-for="(item, accIdx) in filteredArticles" :key="accIdx">
                    <button @click="idx = articles.findIndex((article) => article.acf.episode === item.acf.episode)" class="story__numWrap -alt">
                        <span class="story__num tk-dystopian">#{{ item.acf.episode }}</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
    <article class="story__item">
        <div class="story__phPos">
            <ImageSlider v-if="article.fields.scene_images" :length="article.fields.scene_images.length" :items="article.fields.scene_images" :classNames="['story__phWrap']"></ImageSlider>
            <div class="story__phWrap" v-else>
                <div class="story__ph__noimage">
                    <span class="tk-dystopian">NO IMAGE</span>
                </div>
            </div>
        </div>
        <div class="story__texts">
            <div class="story__title">
                <h3 class="story__text__xl u-font-dsm">
                    <span class="story__num -large c-bg_gold tk-dystopian">#{{ article.fields.episode }}</span>
                    <span class="story__title__text -transformX"><span class="-condensed" v-html="article.fields.title"></span></span>
                </h3>
            </div>
            <dl class="story__block">
                <dt class="c-text-em tk-dystopian">STORY</dt>
                <dd class="story__text" v-if="article.fields.detail">{{ article.fields.detail }}</dd>
                <dd class="story__text" v-else>…準備中。</dd>
            </dl>
            <div class="story__infos">
                <dl class="story__dl">
                    <dt class="c-text-em tk-dystopian">STAFF</dt>
                    <dd class="story__detail" v-if="article.fields.staff">
                        <dl>
                            <div class="story__col" v-for="(item, index) in article.fields.staff" :key="index">
                                <dt class="story__dt">{{ item.position }}：</dt>
                                <dd>{{ item.name }}</dd>
                            </div>
                        </dl>
                    </dd>
                    <dd class="story__text" v-else>…準備中。</dd>
                </dl>
                <div class="story__thumb u-sp">
                    <p class="story__thumb__head c-text-em -ja">次回予告</p>
                    <PlayVideo :id="article.fields.movie_id" :classNames="['story__thumb__btn', '-small']"></PlayVideo>
                </div>
            </div>
            <div class="story__thumb u-pc">
                <p class="story__thumb__head c-text-em -ja">次回予告</p>
                <PlayVideo :id="article.fields.movie_id" :classNames="['story__thumb__btn', '-small']"></PlayVideo>
            </div>
        </div>
    </article>
    <div class="story__arrows">
        <SlideBtn v-model="idx" :length="length"></SlideBtn>
    </div>
</template>
